// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + {"852":"WatchList","858":"FullMovie"}[chunkId] + "." + {"852":"97acc0e8","858":"6ce5f892"}[chunkId] + ".chunk.js";
};